import { defaultCheckError, IRequestAction, progressEpic } from "epics/base-epic";
import { ATS_CUSTOM_TEMPLATES } from "constants/action-types";
import {
    ICreateAtsCustomTemplateActionPayload,
    IUpdateAtsCustomTemplateActionPayload,
    IAddRowActionPayload,
    IDeleteRowActionPayload,
    IUpdateRowActionPayload,
    IUpdateRowSortActionPayload,
} from "actions/ats-custom-template-actions";
import { push, RouterAction } from "react-router-redux";
import { ITemplate, ITemplatePreview } from "constants/template-types";
import { fromJS } from "immutable";
import { buildFetchParams } from "helpers/epics";

export const fetchAtsCustomTemplateEpic = progressEpic<IRequestAction, ITemplate>(
    ATS_CUSTOM_TEMPLATES.FETCH,
    buildFetchParams("GET"),
    {
        checkErrorStatus: defaultCheckError,
    },
);

export const fetchAtsCustomTemplatesEpic = progressEpic<IRequestAction, ITemplatePreview[]>(
    ATS_CUSTOM_TEMPLATES.LIST.FETCH,
    buildFetchParams("GET"),
    {
        checkErrorStatus: defaultCheckError,
    },
);

export const createAtsCustomTemplateEpic = progressEpic<ICreateAtsCustomTemplateActionPayload, RouterAction>(
    ATS_CUSTOM_TEMPLATES.CREATE,
    buildFetchParams("POST"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
        finishActions: (response, _, state) => [
            push(`/brand/${state.scope.brand._id}/admin/ats-reports-templates/${response.id}`),
        ],
    },
);

export const updateAtsCustomTemplateEpic = progressEpic<IUpdateAtsCustomTemplateActionPayload, never>(
    ATS_CUSTOM_TEMPLATES.MUTATE,
    buildFetchParams("PATCH"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
    },
);

export const deleteAtsCustomTemplateEpic = progressEpic<IRequestAction, never>(
    ATS_CUSTOM_TEMPLATES.DELETE,
    buildFetchParams("DELETE"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
        finishActions: (_, __, state) => [push(`/brand/${state.scope.brand._id}/admin/ats-reports-templates`)],
    },
);

export const addTemplateRowEpic = progressEpic<IAddRowActionPayload, never>(
    ATS_CUSTOM_TEMPLATES.FIELD.ADD,
    buildFetchParams("POST"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
        finishActions: (response, _, state) => {
            const templateWithNewRow = fromJS(state.atsCustomTemplates.template.payload)
                .updateIn(["fields"], (fields) => fields.push(response))
                .toJS();

            return [{ type: ATS_CUSTOM_TEMPLATES.UPDATE, payload: templateWithNewRow }];
        },
    },
);

export const deleteTemplateRowEpic = progressEpic<IDeleteRowActionPayload, never>(
    ATS_CUSTOM_TEMPLATES.FIELD.DELETE,
    buildFetchParams("DELETE"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
        finishActions: (_, action, state) => {
            const templateWithDeletedRow = fromJS(state.atsCustomTemplates.template.payload)
                .updateIn(["fields"], (fields) => fields.filter((field) => field.get("id") !== action.payload.fieldId))
                .toJS();

            return [{ type: ATS_CUSTOM_TEMPLATES.UPDATE, payload: templateWithDeletedRow }];
        },
    },
);

export const updateTemplateRowEpic = progressEpic<IUpdateRowActionPayload, never>(
    ATS_CUSTOM_TEMPLATES.FIELD.MUTATE,
    buildFetchParams("PATCH"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
        debounce: 600,
    },
);

export const updateTemplateRowSortEpic = progressEpic<IUpdateRowSortActionPayload, never>(
    ATS_CUSTOM_TEMPLATES.FIELD.SORT,
    buildFetchParams("PUT"),
    {
        mapper: "mergeMap",
        checkErrorStatus: defaultCheckError,
    },
);
